module.exports = __webpack_public_path__ + "static/media/QD.20b2b104.svg";